<template>
  <div id="publishing-suggestion-setting">
    <ipub-model title="Publishing Suggestion Setting"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-drag-area @change="handlerChange"
                      v-model="params" />
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { settingJournalAtype } from '@/api/setting'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    journalId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      count: 0,
      params: [{
        name: 'Encourage',
        key: 'Encourage',
        children: []
      }, {
        name: 'Support',
        key: 'Support',
        children: []
      }, {
        name: 'Not Recommended',
        key: 'Not Recommended',
        children: []
      }]
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = [{
          name: 'Encourage',
          key: 'Encourage',
          children: []
        }, {
          name: 'Support',
          key: 'Support',
          children: []
        }, {
          name: 'Not Recommended',
          key: 'Not Recommended',
          children: []
        }]
        this.count = 0
      } else {
        this.getQuery()
      }
    }
  },
  methods: {
    async getQuery () {
      if (this.journalId) {
        const { encourageList, notRecommendedList, supportList } = await settingJournalAtype.publishSuggestion(this.journalId)
        this.params = [{
          name: 'Encourage',
          key: 'Encourage',
          children: encourageList || []
        }, {
          name: 'Support',
          key: 'Support',
          children: supportList || []
        }, {
          name: 'Not Recommended',
          key: 'Not Recommended',
          children: notRecommendedList || []
        }]
      }
    },
    handlerChange () {
      this.count++
    },
    async confirm () {
      if (this.count) {
        this.$confirm({
          title: `Are you sure you want to save the changes?`,
          content: `Number of data move(s): ${this.count}.`,
          type: 'warning',
          icon: 'iconDetails'
        }).then(async () => {
          const data = {
            encourageCodeList: this.params[0].children ? this.params[0].children.map((item) => { return item.code }) : [],
            supportCodeList: this.params[1].children ? this.params[1].children.map((item) => { return item.code }) : [],
            notRecommendedCodeList: this.params[2].children ? this.params[2].children.map((item) => { return item.code }) : [],
          }
          await settingJournalAtype.setPublishSuggestion(this.journalId, data)
          this.$message.success({
            title: 'Success',
            content: `Data flow successful！`
          })
          this.$emit('confirm')
        })
      } else {
        this.$emit('confirm')
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
